import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-deposits-closed',
  templateUrl: './deposits-closed.component.html',
  styleUrls: ['./deposits-closed.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepositsClosedComponent {
  deadline = new Date(`${environment.withdrawalsDeadline}T00:00:00`)
    .toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  links = [
    { text: 'Telegram', href: 'https://t.me/NeonEvmCommunity' },
    { text: 'Discord', href: 'http://discord.com/invite/neonevm' }
  ];
}
